import SectionHeading from "./SectionHeading";
import conference from "../../Assets/Images/conference_event.png";
import publication from "../../Assets/Images/publication_event.png";
import award from "../../Assets/Images/award_ceremony.png";
import { Link } from "react-router-dom";

const ServiceCards = () => {
  const services = [
    {
      id: 1,
      title: ["Conference", "Event"],
      image: conference,
    },
    {
      id: 2,
      title: ["Publication", "Event"],
      image: publication,
    },
    {
      id: 3,
      title: ["Award", "Ceremony"],
      image: award,
    },
  ];

  return (
    <div className="home-services bg-light py-5">
      <div className="text-center container-fluid">
        <div className="row g-lg-5 justify-content-center">
          {services.map((service) => (
            <div className="col-md-4 col-sm-6" key={service.id}>
              <div className="service-card h-100">
                <div className="image-wrapper mb-3">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="img-fluid"
                  />
                </div>
                <h4 className="p-3">
                  {service.title[0]} <br /> {service.title[1]}
                </h4>
              </div>
            </div>
          ))}
        </div>

        <div className="view-all-button mt-5">
          <Link to="/service">
            <button className="btn rounded-0 px-5">View all Services</button>
          </Link>
        </div>
      </div>
    </div>
  );
};
function HomeServices() {
  return (
    <div>
      <SectionHeading
        secTitle="Our Services"
        secIndex="End-to-End Event Solutions for Every Occasion. Your One-Stop Destination for Event Excellence"
      />
      <ServiceCards />
    </div>
  );
}
export default HomeServices;
